var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"model"},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$store.state.message))]),_c('div',{staticClass:"btn",on:{"click":_vm.query}},[_vm._v(_vm._s(_vm.$t("task.query")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }